import React from "react";
const AddIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "72", height: "72", viewBox: "0 0 72 72", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.4 12v21.6H60v4.8H38.4V60h-4.8V38.4H12v-4.8h21.6V12h4.8z"
  }
));
export {
  AddIcon
};
//# sourceMappingURL=add-icon.js.map
